<template>
  <div class="add-fee-category">
     
      <v-form @submit="submitCategoryDetails" v-model="submitForm">
        <v-row>
          <v-col cols="8">
            <h1 class="text-left ml-8 mt-2">
              <span v-if="!is_editing">Add</span>
              <span v-else>Edit</span> Fee Category
            </h1>
            <h5 class="text-left mx-8">{{ activeFeeSession.title }}</h5>
              <p class="text-left ml-8">Classify students based on their category.</p>
            <h4
              class="text-left ml-8 my-2"
              v-if="category.is_transaction_done"
            >Cannot be edited since Fee Collection is already done using this Fee Category.</h4>
          </v-col>
          <v-col cols="4" class="text-right">
            <v-btn
              v-if="is_editing"
              color="red"
              class="my-2 mr-8"
              @click="showDeleteDialog"
              rounded
              outlined
            >Delete</v-btn>
          </v-col>
        </v-row>
        <v-row class="mx-4">
          <v-col cols="12 pt-0">
            <v-card>
              <v-container>
                <v-row>
                  <v-col cols="12" md="6">
                    <p class="text-left mx-2 mb-1">Category Name</p>
                    <v-text-field
                      v-model="category.title"
                      :error="formErrors.titleError != null"
                      :error-messages="formErrors.titleError"
                      outlined
                      :rules="[rules.required, rules.category_name]"
                      dense
                      placeholder="eg. Other Backward Class"
                      class="rounded-input"
                      hide-details="auto"
                      maxlength="55"
                      @input="formErrors.titleError=null"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="6">
                    <p class="text-left mx-2 mb-1">Code</p>
                    <v-text-field
                      v-model="category.code"
                      :error="formErrors.codeError != null"
                      :error-messages="formErrors.codeError"
                      outlined
                      counter="4"
                      :rules="[rules.required, rules.code]"
                      dense
                      placeholder="eg. OBC"
                      class="rounded-input"
                      maxlength="4"
                      @input="formErrors.codeError=null"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <MapClasses
                      :rooms="selectedRooms"
                      @changed="selectedRoomsChanged"
                      :disabled="category.is_transaction_done || category.students_count > 0"
                    />
                  </v-col>
                   <v-col cols="12">
                    <v-switch
                      class="my-0"
                      v-model="category.restrict_collection_if_pending"
                      label="Restrict fee collection from current session if fee is pending from previous (or other) sessions"
                    ></v-switch>
                  </v-col>
                  <v-col cols="12">
                    <v-switch
                      class="my-0"
                      v-model="category.allow_pending_collection"
                      label="Allow pending fee collection from previous (or other) sessions"
                    ></v-switch>
                  </v-col>
                  <v-col cols="12">
                    <v-switch
                      class="my-0"
                      v-model="category.strict_amount_for_fee_collection"
                      label="Restricts user to enter custom amount for fee collection. Students allocated to this category will have to pay the instalment amount in full."
                    ></v-switch>
                  </v-col>
                </v-row>
                <div class="text-right mx-4 my-4">
                  <v-btn
                    class="mr-4"
                    color="red"
                    :to="{ name: 'FeeSettingsCategory' }"
                    rounded
                    outlined
                  >Cancel</v-btn>

                  <v-btn color="primary" type="submit" :disabled="isLoading || !submitForm" rounded>Submit</v-btn>
                </div>
              </v-container>
            </v-card>
          </v-col>
        </v-row>
      </v-form>

      <DeleteConfirmationDialog
        title="Are you sure you want to delete this Fee Category?"
        :visible="showDeleteConfirmation"
        @deleteObject="deleteObjectConfirmation"
      />

      <v-snackbar v-model="snackbar.visible" timeout="5000" :color="snackbar.color" multi-line>
        {{ snackbar.message }}
        <template v-slot:action="{ attrs }">
          <v-btn dark text v-bind="attrs" @click="snackbar.visible = false">Close</v-btn>
        </template>
      </v-snackbar>
     
  </div>
</template>
<script>
import MapClasses from "@components/widgets/MapClasses";
import { mapGetters, mapActions } from "vuex";
import endpoints from "@api/repository";
import api from "@api/index";
import DeleteConfirmationDialog from "@components/widgets/dialogs/DeleteConfirmationDialog";

export default {
  name: "AddEditFeeCategory",
  components: {
    MapClasses,
    DeleteConfirmationDialog,
  },
  data() {
    return {
      selectedRooms: [],
      is_editing: false,
      formErrors: {
        titleError: null,
        codeError: null,
      },
      submitForm: true,
      rules: {
        required: (v) => !!v || "This field is required",
        category_name: (v) => /^[a-zA-Z0-9_ ]{1,55}$/.test(v) || "Invalid",
        code: (v) => /^[a-zA-Z0-9]{1,4}$/.test(v) || "Invalid"
      },
      category: {
        title: null,
        code: null,
        rooms: null,
        restrict_collection_if_pending: true,
        allow_pending_collection: true,
        strict_amount_for_fee_collection: true,
      },
      showDeleteConfirmation: false,
      snackbar: {
        visible: false,
        message: "",
        color: "dark",
      },
    };
  },
  computed: {
    ...mapGetters(["currentUser", "accessToken", "isLoading", "activeFeeSession"]),
    essentials() {
      return {
        accessToken: this.accessToken,
        setLoading: this.setLoading,
        handleErrorsFunction: this.handleApiErrors,
      };
    },
  },
  methods: {
    ...mapActions(["setLoading"]),
    selectedRoomsChanged(rooms) {
      this.category.rooms = rooms.map((r) => r.id);
    },
    // gets details of category for editing
    async getCategoryDetails() {
      var response;
      response = await api.handleApi({
        apiEssentials: this.essentials,
        url: endpoints.getCategoryById + this.$route.params.id + "/",
        responseVar: response,
      });
      if (response) {
        this.category = response;
      }
    },
    // checks for field errors
    validateFields() {
      Object.keys(this.formErrors).forEach((v) => (this.formErrors[v] = null));
      // if (!this.category.title) {
      //   this.formErrors.titleError = "This field is required";
      //   return false;
      // }
      if (!this.category.code) {
        this.formErrors.codeError = "This field is required";
        return false;
      }
      if (this.category.rooms == null || !this.category.rooms.length > 0) {
        this.snackbar.message = "Classes cannot be empty";
        this.snackbar.color = "error";
        this.snackbar.visible = true;
        return false;
      }

      return true; // ideally
    },
    async submitCategoryDetails(e) {
      e.preventDefault();
      if (!this.validateFields()) return;
      var response;
      response = await api.handleApi({
        apiEssentials: this.essentials,
        url: endpoints.createOrEditCategory,
        responseVar: response,
        method: api.Methods.POST,
        body: {
          category: this.category,
          is_editing: this.is_editing,
          session : this.activeFeeSession.id,
        },
      });
      if (response) {
        this.$router.push({ name: "FeeSettingsCategory" });
      }
    },

    async showDeleteDialog() {
      if (this.category.is_transaction_done) {
        // if yes, do not allow to delete and throw error
        this.snackbar.message =
          "This Fee Category cannot be deleted since fee collection have already been done for the students";
          this.snackbar.color = "error";
        this.snackbar.visible = true;
        return;
      }

      if (this.category.students_count > 0) {
        // if yes, do not allow to delete and throw error
        this.snackbar.message =
          "Cannot be deleted since students have already been assigned this category";
          this.snackbar.color = "error";
        this.snackbar.visible = true;
        return;
      }

      this.showDeleteConfirmation = true;
    },
    async deleteObjectConfirmation(confirm) {
      this.showDeleteConfirmation = false;
      if (confirm) {
        var response;
        response = await api.handleApi({
          apiEssentials: this.essentials,
          url: endpoints.deleteFeeCategory,
          method: api.Methods.POST,
          body: { category_id: this.category.id },
          responseVar: response,
        });
        if (response == true) {
          this.$router.push({ name: "FeeSettingsCategory" });
        }
      }
    },
    async handleApiErrors(err) {
      this.setLoading(false);
      console.log(err);
      if (err.response) {
        if (err.response.status == 409) {
          this.formErrors.codeError = "Code is already used";
          this.snackbar.message =
            "Category Code is already used. Please use a different code";
            this.snackbar.color = "error";
          this.snackbar.visible = true;
        }
      } else {
        this.snackbar.message = "Unable to process request";
            this.snackbar.color = "error";
        this.snackbar.visible = true;
      }
    },
  },
  async created() {
    if (this.$route.params.id) {
      this.is_editing = true;
      await this.getCategoryDetails();
      this.selectedRooms = this.category.rooms;
    }
  },
};
</script>
<style scoped>
.text-white {
  color: white !important;
}
.rounded-input {
  border-radius: 12px !important;
}
</style>